import { NgModule } from '@angular/core';
import {
  ActiveCoaState,
  CheckingAccountState,
  CompanyState,
  CostCenterState,
  EconomicGroupState,
  FinancialRecordDetailsState,
  KeychainState,
  UserState,
} from '@celerofinancas/state-management';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';

/**
 * Store Module
 */
@NgModule({
  imports: [
    NgxsModule.forRoot(
      [
        CostCenterState,
        ActiveCoaState,
        CheckingAccountState,
        CompanyState,
        EconomicGroupState,
        FinancialRecordDetailsState,
        KeychainState,
        UserState,
      ],
      { developmentMode: false },
    ),
    // TODO: Change when env library is ready
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: true }),
  ],
})
export class StoreModule {}
